/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
/*component*/
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopPRClassRegister from '../student/_PopPRClassRegister';
import Modal from '../../component/Inc/Modal';

const PRClassReport = () => {
  const [modalAlert, setModalAlert] = useState(false);
  const [modalPRClassReport, setModalPRClassReport] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '성공', value: 0},
    {title: '실패', value: 1},
    {title: '취소', value: 2},
    {title: '연기', value: 3},
    {title: '미등록', value: 4, type: 'red'},
    {title: '임시저장', value: 5, type: 'red'},
    {title: '내 보고서', value: 6, type: 'divider'}
  ];
  return (
    <>
      <main className="com_container p_pr_class_report">
        <div className="com_center_wrap">
          <section className="com_tit_wrap">
            <h2 className="com_pg_tit icon menu1_2">시범강의 보고서</h2>
            <button
              onClick={() => {
                setModalPRClassReport(true);
              }}
              className="com_btn orange s btn_plus"
            >
              시범강의 보고서 작성
            </button>
          </section>
          <div className="com_pg_container">
            <section className="box">
              <div className="com_board_list__top">
                <section className="com_board_search end">
                  <div className="com_btn_wrap">
                    <button className="com_btn line gray s active">오늘</button>
                    <button className="com_btn line gray s">주간</button>
                    <button className="com_btn line gray s">월간</button>
                  </div>
                  <div className="date_wrap end">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <span className="divider"> ~ </span>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <button className="com_btn gray s">조회</button>
                  </div>
                </section>
              </div>
              <hr className="com_divider" />
              <div className="com_board_list__top">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
                <section className="com_board_search end">
                  <article className="search">
                    <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                    <button className="com_btn gray ws s icon_search"></button>
                  </article>
                </section>
              </div>
              <table className="com_board_list">
                <colgroup>
                  <col width="6%" />
                  <col width="15%" span="6" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>등록일</th>
                    <th>등록자</th>
                    <th>학생명</th>
                    <th>비고</th>
                    <th>요청수업</th>
                    <th>상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>15</td>
                    <td className="td_date">2022,08,25</td>
                    <td>언어김홍보305</td>
                    <td>김학생</td>
                    <td className="td_point">성공</td>
                    <td>영어 외 3종</td>
                    <td className="td_red">승인요청</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td className="td_red">미등록</td>
                    <td>언어김홍보305</td>
                    <td>김학생</td>
                    <td className="td_red">실패</td>
                    <td>-</td>
                    <td className="td_point">
                      승인
                      <br />
                      2023, 05, 12
                    </td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td className="td_date">2022,08,25</td>
                    <td>언어김홍보305</td>
                    <td>김학생</td>
                    <td>취소</td>
                    <td>-</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td className="td_date">2022,08,25</td>
                    <td>언어김홍보305</td>
                    <td>김학생</td>
                    <td>연기</td>
                    <td>-</td>
                    <td className="td_point"></td>
                  </tr>
                  {[11,10,9,8,7,6,5,4,3,2,1].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{i}</td>
                      <td className="td_date">2022,08,25</td>
                      <td>언어김홍보305</td>
                      <td>김학생</td>
                      <td className="td_point">성공</td>
                      <td>영어 외 3종</td>
                      <td className="td_red">승인요청</td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
              <Paging />
            </section>
            <section className="box">
              <div className="detail_tit dot">시범강의 보고서 상세보기</div>
              <div className="com_info">
                <p className="name">홍길동103</p>
                <p className="date dot">2025, 05, 20</p>
                <div className="count">
                  <button className="btn_edit"></button>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_subject name">학생 정보</div>
                <div className="board_item">
                  <div className="info">
                    <span className="tit">학생명</span>
                    <p className="cont com_blue_txt">
                      <b>김학생</b>(고3이상)
                    </p>
                  </div>
                  <div className="info">
                    <span className="tit">휴대폰 번호</span>
                    <span className="cont">010-1234-0134</span>
                  </div>
                  <div className="info">
                    <span className="tit">부 휴대폰</span>
                    <span className="cont">010-1234-0134</span>
                  </div>
                  <div className="info">
                    <span className="tit">모 휴대폰</span>
                    <span className="cont">010-1234-1234</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">시범강의 일시</span>
                    <span className="cont com_blue_txt">2023, 05, 15 11 : 30</span>
                  </div>
                  <div className="info">
                    <span className="tit">시범강의 장소</span>
                    <span className="cont com_blue_txt">서울 특별시 강남구 124 빌딩 5층 금방빌라103</span>
                  </div>
                </div>
                <div className="board_subject name">학생 내신 정보</div>
                <div className="board_item">
                  <div className="info">
                    <span className="tit">학교/성별</span>
                    <span className="cont">대진고등학교/여</span>
                  </div>
                  <div className="info">
                    <span className="tit">학년/계열</span>
                    <span className="cont">3학년/이과</span>
                  </div>
                  <div className="info">
                    <span className="tit">내신 등급</span>
                    <span className="cont com_blue_txt bold">2등급</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit bold">학습상황(학원)</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit bold">학습상황(과외)</span>
                    <span className="cont">-</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit bold">과목상태(국어)</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">모의고사 등급</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">취약부분 및 유형</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업진행 방향</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">
                      (내신)
                      <br />
                      출판사 및 부교재
                    </span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">현재 공부 방법</span>
                    <span className="cont">-</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit bold">과목상태(수학)</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit left">모의고사 등급</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit left">모의고사 등급</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit left">취약부분 및 유형</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit left">수업진행 방향</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit left">
                      (내신)
                      <br />
                      출판사 및 부교재
                    </span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">현재 공부 방법</span>
                    <span className="cont">-</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">고객성격 (학생)</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">고객성격 (학부모)</span>
                    <span className="cont">-</span>
                  </div>
                  <div className="info">
                    <span className="tit">회원요구사항</span>
                    <span className="cont">-</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">첫 수업 가능일</span>
                    <span className="cont com_blue_txt">2022, 08, 25 l 19:30</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업장소</span>
                    <span className="cont">경기도 수원시 팔달구 팔달로1234 모여라 빌딩 203호</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">총 수업료</span>
                    <span className="cont com_blue_txt">124, 000,0000</span>
                  </div>
                  <div className="info">
                    <span className="tit">DC금액 / 사유</span>
                    <span className="cont">형제 할인-50,000 / 2기 수업으로</span>
                  </div>
                  <div className="info">
                    <span className="tit">결제방법</span>
                    <span className="cont">신한카드 / 132-1324-312321</span>
                  </div>
                  <div className="info">
                    <span className="tit">실 결제액</span>
                    <span className="cont com_blue_txt">3개월 / 540,000원</span>
                  </div>
                </div>
                <div className="board_subject name">수업 1</div>
                <div className="board_item">
                  <div className="info">
                    <span className="tit">수업 과목</span>
                    <span className="cont com_blue_txt">과탐</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업상세</span>
                    <span className="cont com_blue_txt">사회문화, 경제, 밥과정서</span>
                  </div>
                  <div className="info">
                    <span className="tit">기수 / 타임</span>
                    <span className="cont com_blue_txt">1기 / 2T</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업 방법</span>
                    <span className="cont com_blue_txt">대면</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">완성여부</span>
                    <span className="cont">N</span>
                  </div>
                  <div className="info">
                    <span className="tit">비교수업</span>
                    <span className="cont">Y</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업 가능일</span>
                    <span className="cont">
                      - 목, 토 l 19:30 ~ 20:30
                      <br />- 금, 일 l 19:30 ~ 19:00
                    </span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">시수</span>
                    <span className="cont">45,000</span>
                  </div>
                  <div className="info">
                    <span className="tit">동시수업</span>
                    <span className="cont">3명</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업료</span>
                    <span className="cont com_blue_txt">2,495,000</span>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="board_item">
                  <div className="info">
                    <span className="cont">
                      <span className="com_icon blue">승인</span>
                      <button className="name">김승인103</button>
                      <span className="date dot">2025, 05, 20 11 : 30</span>
                    </span>
                    <div className="btn_wrap">
                      <button className="btn_edit"></button>
                      <button className="btn_delete"></button>
                    </div>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">수고 하셨습니다.</div>
                </div>
              </div>
              <div className="com_comment_wrap">
                <div className="com_input_wrap">
                  <select className="select">
                    <option value="수업신청 승인">수업신청 승인</option>
                  </select>
                </div>
                <textarea className="textarea" placeholder="김담임 답변하기"></textarea>
              </div>
              <div className="com_btn_wrap center bottom">
                <button className="com_btn orange xs" onClick={() => setModalAlert(true)}>
                  승인
                </button>
              </div>
            </section>
          </div>
        </div>
      </main>
      <PopPRClassRegister open={modalPRClassReport} close={() => setModalPRClassReport(false)} />
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt">
            승인 하시면
            <br />
            수업등록 요청이 진행됩니다.
          </div>
          <div className="btn_container">
            <button className="com_btn lightGray xs" onClick={() => setModalAlert(false)}>
              취소
            </button>
            <button className="com_btn orange xs">이동</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PRClassReport;
